import React from 'react';
import { isNil } from 'lodash';
import Anchor from '../../../../components/link/Anchor';

const OpenPreviewTagDetail = (props) => {
  const { text, tagId, getTagPreviewData } = props;

  /**
   * 링크로 연결할 데이터가 없다면
   * '-' 를 반환함
   */
  if (isNil(text) || isNil(tagId)) {
    return '-';
  }

  return (
    <Anchor
      color="primary"
      isUnderLine
      text={text}
      onClick={() =>
        getTagPreviewData({
          tagId,
        })
      }
    />
  );
};

export default OpenPreviewTagDetail;
